<template>
    <component
        :is="componentName"
        :meta="meta"
        ref="gridInstance"
        :toolbarShow="toolbarShow"
        :filterPanelShow="filterPanelShow"
        :selectionMode="selectionMode"
        :totalCountSelectedShow="totalCountSelectedShow"
        :filterRow="filterRow"
        :customContextMenu="customContextMenu"
        :set-context="setContext"
        @toolbar-button-click="toolbarButtonClick"
        @grid-columns-width-changed="onGridColumnsWidthChanged"
        @user-settings-changed="onUserSettingsChanged"
        @grid-virtual-base-mounted="onGridVirtualBaseMounted"
        @focusedRowChanging="onFocusRowChanging"
        @user-settings-save="onUserSettingsSave"
        @selection-changed="onSelectionChanged"
        @reset-user-settings="onResetUserSettings"
    />
</template>

<script>
import AiGridVirtualBase from '@/components/ai-grid-virtual/ai-grid-virtual-base.vue';

export default {
    name: 'ai-grid-virtual',
    components: { AiGridVirtualBase },
};
</script>
<script setup>
import { ref, watch } from 'vue';

const componentName = ref('ai-grid-virtual-base');
const emits = defineEmits([
    'selectionChanged',
    'gridVirtualMounted',
    'toolbarButtonClick',
    'gridColumnsWidthChanged',
    'userSettingsChanged',
    'resetUserSettings',
    'focusedRowChanging',
]);
const props = defineProps({
    meta: {
        type: Object,
        default: () => {
            return { columns: [] };
        },
    },
    findText: {
        type: String,
        default: () => {
            return '';
        },
    },
    filterPanelShow: {
        type: Boolean,
        default: () => {
            return undefined;
        },
    },
    toolbarShow: {
        type: Boolean,
        default: true,
    },
    selectionMode: {
        type: String,
    },
    totalCountSelectedShow: {
        type: Boolean,
        default: () => true,
    },
    filterRow: {
        type: Object,
        default: () => {
            return undefined;
        },
    },
    customContextMenu: {
        type: Array,
        default: () => [],
    },
    setContext: {
        type: Function,
        default: null,
    },
});
const toolbarButtonClick = e => {
    emits('toolbarButtonClick', e);
};

const onUserSettingsChanged = (userSettings, autoSaveMode) => {
    emits('userSettingsChanged', userSettings, autoSaveMode);
};

const onGridVirtualBaseMounted = () => {
    emits('gridVirtualMounted');
};

const onSelectionChanged = e => {
    emits('selectionChanged', e);
};

const onUserSettingsSave = () => {
    emits('userSettingsSave');
};

const onResetUserSettings = () => {
    emits('resetUserSettings');
};

watch(
    () => props.findText,
    () => {
        gridInstance.value.gridInstance.searchByText(props.findText);
    }
);
const gridInstance = ref(null);
const getUserSettings = () => {
    return gridInstance.value.getUserSettings();
};
const setUserSettings = settings => {
    return gridInstance.value.setUserSettings(settings);
};

const onFocusRowChanging = e => {
    emits('focusedRowChanging', e);
};

defineExpose({
    gridInstance,
    getUserSettings,
    setUserSettings,
});
</script>

<style scoped></style>
